<div class="frontpage-widget cover-image-trees-gray">
  <div class="whitebox dark-blue">
      <div class="container">
          <p class="text-muted">V1-KLADDER <i class="fa fa-chevron-right"></i></p>
          <h2 i18n>Find lokation i JAR</h2>
          <p><span class="text-muted">Indtast lokationsnummer fra JAR for at starte en kladdescreening</span></p>
      </div>
  </div>
</div>

<div class="container my-5">
  <div class="row">   
    <div class="col-sm-12 col-lg-12">
      <div >
        <div class="vd-main-search-bar no-searchresults" [ngClass]="{'no-searchresults': !displaySearchResults}" >
          <input type="text" id="searchInput" [(ngModel)]="searchText" aria-describedby="searchinput" placeholder="Indtast lokationnummer fra JAR">
          <div>
            <button class="btn btn-secondary" (click)="onSearch()">SØG <i class="fa fa-search"></i></button>
          </div>
        </div>

      </div>
    </div>
  </div>
  <div class="row mt-4 vd-fade fast" [ngClass]="{'in': displaySearchResults, 'out': !displaySearchResults}">
    <div class="col-sm-12 col-lg-12">
      <div class="vd-card p-5">
        <div class="row">
          <div class="col-12">
            <h4 i18n><i class="fa fa-check-circle text-success fa-lg"></i> Vi fandt sagen</h4>
            <p class="text-muted">Følgende oplysninger er registreret på sagen:</p>
          </div>
        </div>

        <hr/>

        <div class="row mt-2 screening-result">
          <div class="col-lg-3 col-sm-12">
              <div class="form-group">
                  <label for="polutant">Lokationsnummer:</label>
                  <div class="result-value">
                      <span i18n>2233-44556</span>
                  </div>
              </div>

              <div class="form-group">
                  <label for="polutant">Brancher:</label>
                  <div class="result-value">
                      <span >Kemisk industri, Garveri</span>
                  </div>
              </div>

          </div>

          <div class="col-lg-9 col-sm-12">

              <div class="form-group">
                  <label for="polutant">Adresse:</label>
                  <div class="result-value">
                      <span >Nordgårdsvej 1, 7190 Billund</span>
                  </div>
              </div>

              <div class="form-group">
                  <label for="polutant">Brancheaktiviteter:</label>
                  <div class="result-value">
                      <span i18n>Chlorerede opløsningsmidler, Dichlorethylen, Tetrachlorethylen, Trichoretylen</span>
                  </div>
              </div>
          </div>
        </div>
        <hr/>
        <div class="row mt-4">
          <div class="col col-12">
            <button class="btn btn-primary" routerLink="/draft-screening/init-draft"><i class="fa fa-play"></i> Start ny foreløbig screening</button>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>